import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.js';

// 1. This finds the <div id="root"></div> in your public/index.html file.
const root = ReactDOM.createRoot(document.getElementById('root'));

// 2. This renders your entire application inside that div.
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

